import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { IGetApiTokenBalanceResponse } from '@apps/flying/shared';

import { ENVIRONMENT } from '../../../../environments';
import { ApiTokenBalanceReconciler, TypeApiTokenBalanceSetter } from './api-token-balance-reconciler';


/**
 * Refreshes API-credit state after paid requests settle. Cancellation closes the
 * client connection before the backend refund transaction necessarily completes,
 * so reconciliation deliberately samples the authoritative balance more than once.
 */
@Injectable({
	providedIn: 'root'
})
export class ApiTokenBalanceReconciliationService {
	private readonly TOKEN_BALANCE_URL: string = `${ENVIRONMENT.BACKEND.SERVER_URL}user/api-token-balance`;
	private readonly reconciler: ApiTokenBalanceReconciler;

	constructor(
		private http: HttpClient
	) {
		this.reconciler = new ApiTokenBalanceReconciler(() => {
			return this.http.get<IGetApiTokenBalanceResponse>(this.TOKEN_BALANCE_URL)
				.pipe(map((tokens: IGetApiTokenBalanceResponse) => tokens.tokenBalance));
		});
	}

	refresh(setBalance: TypeApiTokenBalanceSetter): void {
		this.reconciler.refresh(setBalance);
	}

	reconcileAfterSettlement(setBalance: TypeApiTokenBalanceSetter): void {
		this.reconciler.reconcileAfterSettlement(setBalance);
	}

	reconcileAfterSseError(error: unknown, setBalance: TypeApiTokenBalanceSetter): void {
		this.reconciler.reconcileAfterSseError(error, setBalance);
	}
}

export { isSseTransportError } from './api-token-balance-reconciler';
